import * as Yup from 'yup';
import { IntlShape } from 'react-intl';

export const unitDescriptionValidation = (intl: IntlShape) =>
    Yup.object().shape({
        descriptionLayout: Yup.string().required(intl.formatMessage({ defaultMessage: 'Dit veld mag niet leeg zijn' })),
    });
